import type {FC} from 'react'
import {displayFormat} from 'libs/formatter'
import {csvProcedureEmployeeName} from '../List'
import {AttachmentsProps} from './ApplyFormDetail'
import {AttachmentItem} from '../AttachmentItem'

// @ts-ignore
import ListGroup from 'jbc-front/components/ListGroup'

export const CsvProcedureAttachments: FC<AttachmentsProps> = ({egovProcedure}) => (
  <>
    <ListGroup>
      <ListGroup.Title>手続き名称</ListGroup.Title>
      <ListGroup.Item>{egovProcedure.formName}</ListGroup.Item>
    </ListGroup>

    <ListGroup>
      <ListGroup.Title>対象従業員</ListGroup.Title>
      <ListGroup.Item>{csvProcedureEmployeeName(egovProcedure.csvProcedure)}</ListGroup.Item>
    </ListGroup>

    <ListGroup>
      <ListGroup.Title>添付書類</ListGroup.Title>
      {egovProcedure.attachments.length > 0 ? (
        egovProcedure.attachments.map((attachment, i) => (
          <ListGroup.Item key={`attachment-key-${i}`}>
            <AttachmentItem egovProcedure={egovProcedure} attachment={attachment} />
          </ListGroup.Item>
        ))
      ) : (
        <ListGroup.Item>{displayFormat()}</ListGroup.Item>
      )}
    </ListGroup>
  </>
)
